import type React from 'react';
import { useWizard, WizardSubStep } from '@zillow/zrs-rental-applications';

interface RenderSubStepProps {
  id: string;
  label: string;
  hidden?: boolean;
  render: () => React.ReactElement;
}

// Avoiding rendering the actual component until necessary. This avoids hooks being fired off before the step is being rendered
export default function RenderSubStep({ id, label, hidden = false, render }: RenderSubStepProps) {
  const { currentSubStep } = useWizard();
  if (currentSubStep !== id) {
    return <WizardSubStep id={id} label={label} hidden={hidden} render={() => null} />;
  }
  return render();
}
